<section class="summary-page">
  <div class="page-header">
    <div>
      <div class="eyebrow">Available</div>
      <h1>Handoff summary</h1>
      @if (handoff(); as row) {
        <p>{{ customerLabel(row) }} · {{ formatCreatedAt(row.created_at) }}</p>
      }
    </div>

    <a class="primary-teal-btn back-btn" routerLink="/available">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>
      Back
    </a>
  </div>

  @if (loading()) {
    <div class="state-panel">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }

  @if (!loading() && error()) {
    <div class="state-panel error-panel">{{ error() }}</div>
  }

  @if (!loading()) {
    @if (handoff(); as row) {
      <div class="summary-grid">

        <section class="card overview-card">
          <div class="card-title">Overview</div>

          <div class="kv-grid">
            <div class="kv">
              <span>Customer</span>
              <strong>{{ customerLabel(row) }}</strong>
              @if (row.customer_phone) {
                <span class="kv-sub">{{ row.customer_phone }}</span>
              }
              @if (row.customer_address) {
                <span class="kv-sub">{{ row.customer_address }}</span>
              }
            </div>

            <div class="kv">
              <span>Status</span>
              <strong>{{ row.status }}</strong>
            </div>

            <div class="kv">
              <span>Created</span>
              <strong>{{ row.created_at | date: 'MMM d, y, h:mm a' }}</strong>
            </div>

            <div class="kv">
              <span>Time</span>
              <strong>{{ formatCreatedAt(row.created_at) }}</strong>
            </div>

            <div class="kv">
              <span>City</span>
              <strong>{{ row.city_code || '—' }}</strong>
            </div>

            <div class="kv">
              <span>Category</span>
              <strong>{{ selectedCategory(row) || '—' }}</strong>
            </div>

            <div class="kv full">
              <span>Reason</span>
              <strong>{{ reasonLabel(row.reason) }}</strong>
            </div>
          </div>
        </section>

        <section class="card">
          <div class="card-title">Operator summary</div>
          <op-handoff-summary-card [row]="row" />
        </section>

        <section class="card">
          <div class="card-title">Category</div>
          <div class="body-text small">{{ selectedCategory(row) || '—' }}</div>
        </section>
      </div>
      @if (row.status === 'PENDING') {
        <div class="claim-fab">
          <button
            class="primary-green-btn"
            [disabled]="claiming()"
            (click)="claim(row)"
          >
            @if (claiming()) {
              Claiming…
            } @else {
              Claim Case
            }
          </button>
        </div>
      }
    }
  }
</section>
